import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Fetch, Figure, Frame } from '@studiometa/ui';
import { isDev } from './config.js';
import Hero from './components/Hero.js';
import ParallaxMedia from './components/ParallaxMedia.js';
import Fade from './components/Fade.js';
import Menu from './components/Menu/index.js';
import Terroirs from './components/Terroirs.js';
import AnchorNav from './components/AnchorNav.js';
import Evin from './components/Evin.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Figure,
      Hero,
      ParallaxMedia,
      Menu,
      Frame,
      Action,
      Evin,
      Fetch,
      Terroirs,
      '[data-fade]': Fade,
      Timeline: () => importWhenVisible(() => import('./components/Timeline.js'), 'Timeline'),
      TextReveal: () => importWhenVisible(() => import('./components/TextReveal.js'), 'TextReveal'),
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
      Domains: () => importWhenVisible(() => import('./components/Domains.js'), 'Domains'),
      ChartBlock: () => importWhenVisible(() => import('./components/ChartBlock.js'), 'ChartBlock'),
      AnchorNav,
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
